import { Button, } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Pricelist } from 'common-models';

import { FC, useEffect, useState } from 'react';
import { useAuth } from "react-oidc-context";
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { useGetAllPricelistsQuery } from '../../features/events/eventsApiSlice';
import { Model } from '../../lib/Model';
import PricelistEditor from './PricelistEditor';

const PricelistsView: FC<any> = () => {
    const auth = useAuth();

    const { data: pricelistsFromApi = new Array<Pricelist>() } = useGetAllPricelistsQuery(auth.user?.access_token ?? '');

    const [allPricelists, setAllPricelists] = useState([] as Array<Pricelist>);
    const [currentPricelist, setCurrentPricelist] = useState(undefined as unknown as Pricelist);

    useEffect(() => {

        const converted = pricelistsFromApi.map(Model.deepCopyPricelist);
        setAllPricelists(new Array<Pricelist>(...converted));
    }, [pricelistsFromApi])

    function editPricelist(pricelist: Pricelist) {
        setCurrentPricelist(pricelist);

    }

    function closeEditor() {
        setCurrentPricelist(undefined as unknown as Pricelist);
    }

    function createNewPriceList() {
        setCurrentPricelist({
            id: uuidv4(),
            name: '',
            products: []
        });
    }

    return (
        <>
            <Grid container>

                {
                    currentPricelist !== undefined
                        ? <></>
                        : <>
                            <Grid container className='event-gallery-admin-pricelist-tools'>
                                <Grid size="auto">
                                    <Button
                                        variant='contained'
                                        onClick={createNewPriceList}
                                    >
                                        Add new pricelist
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container>
                                {
                                    allPricelists.map(x => {
                                        return <Grid container key={`pricelist|${x.id}`}>

                                            <Link
                                                //variant='contained'
                                                to='#'
                                                onClick={() => editPricelist(x)}
                                            >
                                                {x.name}
                                            </Link>
                                        </Grid>
                                    })
                                }
                            </Grid>
                        </>
                }
            </Grid>

            {
                currentPricelist !== undefined
                    ? <PricelistEditor
                        Pricelist={currentPricelist}
                        accessToken={auth.user?.access_token ?? ''}
                        onSavedCallback={closeEditor}
                        onCanceledCallback={closeEditor}
                    />
                    : <></>
            }
        </>
    )
}

export default PricelistsView;
